import { createRouter, createWebHistory } from "vue-router";

// Layouts
import DashboardLayout from "@/layout/DashboardLayout";
import LayoutClient from "@/layout/LayoutClient";

// Middleware
import Guard from "../services/middleware";

// Views Gerais
import RTL from "../views/Rtl.vue";
import Home from "../views/Site/index.vue";
import Login from "../views/Site/Login.vue";
import Registro from "../views/Site/Registro.vue";
import Signin from "../views/Signin.vue";

// Painel Admin
import Dashboard from "../views/Painel/Dashboard.vue";
import Usuarios from "../views/Painel/Usuarios.vue";
import CadastrarUsusario from "../views/Painel/CadastrarUsusario.vue";
import Configuracao from "../views/Painel/Configuracao.vue";
import Pontuacao from "../views/Painel/Pontuacao.vue";
import Tarefas from "../views/Painel/Tarefas.vue";
import Horarios from "../views/Painel/Horarios.vue";
import Colaboradores from "../views/Painel/Colaboradores.vue";
import CadastrarColaborador from "../views/Painel/CadastrarColaborador.vue";
import AcessoBling from "../views/Painel/AcessoBling.vue";
import ValidacaoBling from "../views/Painel/ValidacaoBling.vue";

const routes = [
  // Rota de login do admin
  
  {
    path: "/",
    name: "Inicial",
    redirect: "/login"
  },

  {
    path: "/admin/login",
    name: "Signin",
    component: Signin,
  },

  // Validação externa
  {
    path: "/validacao-bling",
    name: "ValidacaoBling",
    component: ValidacaoBling,
  },

  // Rotas públicas
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/registrar-se",
    name: "Registro",
    component: Registro,
  },

  // Cliente (usuário comum)
  {
    path: "/dashboard",
    component: LayoutClient,
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
        beforeEnter: Guard.authCliente,
      },
      {
        path: "pagina-inicial",
        name: "PaginaInicial",
        component: () => import("../views/Dashboard/PaginaInicial.vue"),
        beforeEnter: Guard.authCliente,
      },
      {
        path: "cortes",
        name: "Cortes",
        component: () => import("../views/Dashboard/Cortes.vue"),
        beforeEnter: Guard.authCliente,
      },
      {
        path: "pedidos",
        name: "Pedidos",
        component: () => import("../views/Dashboard/Pedidos.vue"),
        beforeEnter: Guard.authCliente,
      },
    ],
  },

  // Admin (painel administrativo)
  {
    path: "/admin",
    component: DashboardLayout,
    beforeEnter: Guard.authAdmin, 
    children: [

      {
        path: "",
        redirect: "dashboard"
      },
      {
        path: "dashboard",
        name: "AdminDashboard",
        component: Dashboard
      },
      {
        path: "rtl-page",
        name: "RTL",
        component: RTL
      },
      {
        path: "usuarios",
        name: "Usuarios",
        component: Usuarios
      },
      {
        path: "alterar-usuario/:id",
        name: "AlterarUsuario",
        component: CadastrarUsusario
      },
      {
        path: "cadastrar-usuario",
        name: "CadastrarUsuario",
        component: CadastrarUsusario
      },
      {
        path: "configuracao",
        name: "Configuracao",
        component: Configuracao
      },
      {
        path: "colaboradores",
        name: "Colaboradores",
        component: Colaboradores
      },
      {
        path: "cadastrar-colaborador",
        name: "CadastrarColaborador",
        component: CadastrarColaborador
      },
      {
        path: "alterar-colaborador/:id",
        name: "AlterarColaborador",
        component: CadastrarColaborador
      },
      {
        path: "pontuacao",
        name: "Pontuacao",
        component: Pontuacao
      },
      {
        path: "horarios",
        name: "Horarios",
        component: Horarios
      },
      {
        path: "tarefas",
        name: "Tarefas",
        component: Tarefas
      },
      {
        path: "acesso-bling",
        name: "AcessoBling",
        component: AcessoBling
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;